"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _reactRedux = require("react-redux");
var _admin = require("../../../../selectors/admin.js");
var _cccisdFormik = require("cccisd-formik");
var _MultiCheckbox = _interopRequireDefault(require("../MultiCheckbox"));
var _immutabilityHelper = _interopRequireDefault(require("immutability-helper"));
var _getDeploymentsIgnored = _interopRequireDefault(require("./getDeploymentsIgnored.js"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
var AssignmentForm = function AssignmentForm(props) {
  var values = props.values,
    setFieldValue = props.setFieldValue;
  var isInitialMount = (0, _react.useRef)(true);
  var adminState = (0, _reactRedux.useSelector)(function (state) {
    return state.assignment.admin;
  });
  var assignmentList = (0, _reactRedux.useSelector)(function (state) {
    return (0, _admin.getCurrentProjectActiveAssignments)(adminState);
  });
  var visibleDeploymentIds = adminState.visibleDeploymentIds;
  var _useMemo = (0, _react.useMemo)(function () {
      var adjustedState = (0, _immutabilityHelper["default"])(adminState, {
        currentQuerySettings: {
          assignmentId: {
            $set: Number(values.assignmentId)
          }
        }
      });
      var deploymentListLocal = (0, _admin.getCurrentQueryAssignmentActiveDeployments)(adjustedState);
      var surveyList = (0, _admin.getCurrentQueryAssignmentActiveSurveys)(adjustedState);
      return {
        deploymentList: deploymentListLocal,
        deploymentOptions: deploymentListLocal.map(function (item) {
          return {
            value: item.deploymentId,
            label: item.label
          };
        }),
        surveyOptions: surveyList.map(function (item) {
          return {
            value: item.surveyHandle,
            label: item.label
          };
        })
      };
    }, [adminState, values.assignmentId]),
    deploymentList = _useMemo.deploymentList,
    deploymentOptions = _useMemo.deploymentOptions,
    surveyOptions = _useMemo.surveyOptions;
  var ignoredDeployments = (0, _react.useMemo)(function () {
    return (0, _getDeploymentsIgnored["default"])(deploymentList, values.deploymentIds, values.surveyHandles);
  }, [deploymentList, values]);
  var assignmentOptions = (0, _react.useMemo)(function () {
    if (!visibleDeploymentIds) {
      return assignmentList.map(function (item) {
        return {
          value: item.assignmentId,
          label: item.label
        };
      });
    }
    var deploymentIdsSet = new Set(visibleDeploymentIds);
    return assignmentList.filter(function (item) {
      return item.deploymentList.some(function (deployment) {
        return deploymentIdsSet.has(deployment.deploymentId);
      });
    }).map(function (item) {
      return {
        value: item.assignmentId,
        label: item.label
      };
    });
  }, [assignmentList, visibleDeploymentIds]);
  (0, _react.useEffect)(function () {
    if (isInitialMount.current) {
      isInitialMount.current = false;
      return;
    }
    setFieldValue('deploymentIds', 'all');
    setFieldValue('surveyHandles', 'all');
    setFieldValue('filter', null);
  }, [deploymentOptions, surveyOptions, values.assignmentId]);
  if (assignmentOptions.length === 0) {
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: "alert alert-info"
    }, /*#__PURE__*/_react["default"].createElement("strong", null, "There are no active Quests that contain data collection waves."), " You can create a new data collection wave from the Deploy tab.");
  }
  return /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Field, {
    name: "assignmentId",
    component: _cccisdFormik.CccisdSelect,
    label: "Quest",
    options: assignmentOptions,
    style: {
      width: 'auto',
      maxWidth: '100%'
    }
  }), /*#__PURE__*/_react["default"].createElement("div", {
    style: {
      marginBottom: '0.5em'
    }
  }, ignoredDeployments.length > 0 && /*#__PURE__*/_react["default"].createElement("div", {
    className: "alert alert-warning"
  }, /*#__PURE__*/_react["default"].createElement("b", null, "Warning:"), " Responses for some Data Collection Waves may be included but not show any data, as all surveys currently assigned to these Data Collection Waves have been deselected."), /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Field, {
    name: "deploymentIds",
    component: _MultiCheckbox["default"],
    label: "Data Collection Waves",
    options: deploymentOptions,
    warningOptions: ignoredDeployments,
    warningMessage: "All related surveys are deselected"
  })), /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Field, {
    name: "surveyHandles",
    component: _MultiCheckbox["default"],
    label: "Surveys",
    options: surveyOptions
  }));
};
var _default = exports["default"] = AssignmentForm;